import './index_mWeb.css';
import { useLink } from 'react-router-stack';
import { HeaderWithTimer, View, Text, FlatListWrapper, RouteWrapper } from '../../../component';
import I18n from '../../../utilities/locale';
import { getPlayerName } from '../../../utilities/helper';
import FlatList from 'flatlist-react';
import ChooseCapPlayerRowMWeb from '../../component/choose_cap_player_row/index_mWeb';
import Button from '@mui/material/Button/Button';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';
import { useSelector } from 'react-redux';

interface playerTypeProps {
  data: any;
  captain?: boolean;
  viceCaptain?: boolean;
}

const PlayerType = ({ data, captain }: playerTypeProps) => {
  const { shortName = '' } = data;
  const playerTypeTitle = { color: '#ffc400' };
  return (
    <View className={'choose-captain-player-type-container'}>
      <Text className={'choose-captain-player-type-name__mWeb'} style={playerTypeTitle}>
        {shortName.length > 0 ? `${getPlayerName(shortName)}` : 'Select'}
      </Text>
      <View style={{ flexDirection: 'row' }}>
        <Text className={'choose-captain-player-type-captain_mWeb'}>
          {captain ? 'Captain' : 'Vice Captain'}
        </Text>
        <Text className={'choose-captain-player-type-captain_mWeb'} style={{ fontWeight: 'bold' }}>
          &nbsp;{captain ? '| 2x Points' : ' | 1.5x Points'}
        </Text>
      </View>
    </View>
  );
};

interface headerProps {
  captain: any;
  viceCaptain: any;
}

const Header = ({ captain, viceCaptain }: headerProps) => {
  const headerContainerColor = {
    backgroundColor: '#192330'
  };
  const separator = {
    backgroundColor: '#596779'
  };
  return (
    <View className={'choose-captain-header-container_mWeb'} style={headerContainerColor}>
      <View className={'choose-captain-header-wrapper_mWeb'}>
        <View className={'choose-captain-header-tab_mWeb'}>
          <PlayerType data={captain} captain={true} viceCaptain={false} />
        </View>
        <View className={'choose-captain-header-item-separator_mWeb'} style={separator} />
        <View className={'choose-captain-header-tab_mWeb'}>
          <PlayerType data={viceCaptain} captain={false} viceCaptain={true} />
        </View>
      </View>
    </View>
  );
};

const ChooseCaptainMWeb = ({
  matchItem,
  gameType,
  selectedPlayer,
  selectedCaptain,
  selectedViceCaptain,
  teamA,
  teamB,
  captainData,
  viceCaptainData,
  onPressContinue,
  teamNumber
}: any) => {
  const navigate = useLink();
  const { teamName = '' } = useSelector((state: any) => state.user);
  const renderItemPlayers = (item: any) => {
    return (
      <ChooseCapPlayerRowMWeb
        item={item}
        selectedCaptain={selectedCaptain}
        selectedViceCaptain={selectedViceCaptain}
        teamA={teamA}
        teamB={teamB}
        gameType={gameType}
      />
    );
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onCalledDeadline = () => {
    navigate.push('/', { replace: true });
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <div
          className="choose_captain_vice_captain_wrapper_mWeb"
          id="choose_captain_vice_captain_cricket_mWeb">
          <HeaderWithTimer
            onlyTimer={true}
            onPressBack={onPressBack}
            matchItem={matchItem}
            onCalledDeadline={onCalledDeadline}
            teamName={`${teamName} (T${teamNumber})`}
            isCreateTeam={true}
          />
          <View className={'choose-captain-container_mWeb'}>
            <Header captain={captainData} viceCaptain={viceCaptainData} />
            <View className={'choose-captain-sub-container_mWeb'}>
              <Text
                className={'choose-captain-vice-label_mWeb'}
                style={{
                  color: '#fff'
                }}>
                {'Choose your Captain & Vice Captain'}
              </Text>

              <View className={'choose-captain-list-container_mWeb'}>
                <div className={'flat-list-outer'}>
                  <FlatListWrapper className={'flat-list-padding'}>
                    <FlatList list={selectedPlayer} renderItem={renderItemPlayers} renderOnScroll />
                  </FlatListWrapper>
                </div>
                <View className={'choose-captain-bottom-card_mWeb'}>
                  <Button
                    onClick={onPressContinue}
                    className={'choose-captain-button_mWeb'}
                    style={{
                      backgroundColor: '#00A500',
                      // shadowColor: theme.chooseCaptainContinueBtn,
                      color: '#fff'
                    }}>
                    {I18n.t('SaveTeam')}
                  </Button>
                </View>
              </View>
            </View>
          </View>
        </div>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default ChooseCaptainMWeb;
